import { Component, Input, OnInit } from '@angular/core';
import { Product } from 'src/app/modules/shared/models/products.model';

@Component({
  selector: 'product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss'],
})
export class ProductDescriptionComponent implements OnInit {
  @Input() product: Product;
  productDesc: string;
  constructor() {}

  ngOnInit(): void {
    this.setProductDescription();
  }

  private setProductDescription() {
    try {
      const descList = JSON.parse(
        this.product?.store_product_detail?.description ||
          this.product?.description
      );
      this.productDesc = descList.content.find(
        (item) =>
          item.type === 'marketing' || item.type === 'Marketing Description'
      );
    } catch (error) {}
  }
}
